module.exports = __webpack_public_path__ + "static/media/referral-background.d871861c.png";